:host {
  padding: calc(var(--spacer) * 3);
}

.sensor-requirement {
  padding: 0 calc(3 * var(--spacer)) calc(3 * var(--spacer)) 0;
  margin-bottom: calc(2 * var(--spacer));
  --font-family: var(--font-family-secondary);
}

.sensor-title {
  font-size: 14px;
  font-weight: 600 !important;
}

.text-margin-top {
  margin-top: calc(var(--spacer));
}

div > ol {
  padding: 0;
}

ol {
  counter-reset: item;
}

ol > li {
  display: block;
}

ol > li:before {
  content: counters(item, '.') '. ';
  counter-increment: item;
}
